import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useControlAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const control = ref({ responsible_id: null })
  const isSubmitting = ref(false)
  const collection = 'control'

  const create = async (data, redirect = true) => {
    if (!hasPermission('controls', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        client_id: oid(userData.client.$oid),
        name: data.name,
        responsible_id: data.responsible_id ? oid(data.responsible_id) : null,
        behaviours: data.behaviours?.map(e => oid(e)) || [],
        history: [createInitialAuditEntry()],
      }

      const { insertedId } = await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.control_added'))
      return insertedId
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.control_add_error'))
    } finally {
      if (redirect) router.push({ name: 'organization-control-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    control,
    isSubmitting,
  }
}
